import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Image,
  ListItem,
  Text,
  UnorderedList,
  useBreakpointValue
} from "@chakra-ui/react";

import { ModalDefault } from "./ModalDefault";

export function ModalInmetro({ isOpen, onClose }) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <ModalDefault open={isOpen} close={onClose} title="Inmetro">
      <Accordion defaultIndex={[0]}>
        <AccordionItem mb="0.5rem">
          <AccordionButton
            bgColor={"ll-blue.main"}
            borderRadius={"50px"}
            _hover={{
              opacity: "0.5"
            }}
          >
            <Box textAlign={"start"} color={"ll-white.main"} w={"full"}>
              RESISTÊNCIA AO ROLAMENTO
            </Box>
            <AccordionIcon color="white" />
          </AccordionButton>
          <AccordionPanel>
            <Flex w="full" justifyContent="space-between">
              <Flex
                w={{ base: "full", lg: "60%" }}
                direction="column"
                fontSize={{ base: "text1", lg: "h4" }}
                mt="0.5rem"
              >
                <Text textStyle="Regular">
                  A resistência ao rolamento é indicada através de uma escala de letras que vai de
                  "A" (mais eficiente) a "G" (menos eficiente).
                </Text>
                <Text mt="1rem" textStyle="Regular">
                  Este índice está relacionado ao consumo de combustível. Um pneu, por exemplo, de
                  grau "B" apresenta um consumo de combustível 1,5% menor que um pneu graduado como
                  "C" (o que dá em média 60 litros de combustível ao final da vida útil do jogo de
                  pneus).
                </Text>
                <Text mt="1rem" textStyle="Regular">
                  A diferença de consumo entre um pneu grau "A" e outro de grau "G" chega a ser de
                  7,5%.
                </Text>
                <Text mt="1rem" textStyle="Regular">
                  A letra D não é usada em pneus de passeio e camionete (ou seja: nesses casos, um
                  pneu "E" é imediatamente inferior a um pneu "C").
                </Text>
                <Text mt="1rem" textStyle="Regular">
                  <Text as="span" textStyle="Bold">
                    Dica:
                  </Text>{" "}
                  Um pneu com pressão de calibragem abaixo da recomendada tem maior resistência ao
                  rolamento e consequentemente maior consumo de combustível.
                </Text>
              </Flex>
              {isWideVersion && (
                <Flex
                  w={{ base: "55%", lg: "246px" }}
                  h={{ base: "auto", lg: "409px" }}
                  position="relative"
                >
                  <Box
                    top={{ base: "50px", lg: "0" }}
                    left={{ base: "-10px", lg: "0" }}
                    position={{ base: "absolute", lg: "relative" }}
                    w={{ base: "346px", lg: "246px" }}
                    h={{ base: "509px", lg: "409px" }}
                  >
                    <Image
                      src="https://cdn.pneufree.com.br/CMS/images/Geral/01-28-2020-14-26r-eficiencia.png"
                      w="full"
                      alt="Inmetro"
                    />
                  </Box>
                </Flex>
              )}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem mb="0.5rem">
          <AccordionButton
            bgColor={"ll-blue.main"}
            borderRadius={"50px"}
            _hover={{
              opacity: "0.5"
            }}
          >
            <Box textAlign={"start"} color={"ll-white.main"} w={"full"}>
              FRENAGEM NO MOLHADO
            </Box>
            <AccordionIcon color="white" />
          </AccordionButton>
          <AccordionPanel>
            <Flex w="full" justifyContent="space-between">
              <Flex w={{ base: "full", lg: "60%" }} direction="column" mt="0.5rem">
                <Text textStyle="Regular" fontSize={{ base: "text1", lg: "h4" }}>
                  Índice apresentado em uma escala de letras, sendo "A" o de melhor desempenho e "F"
                  o pior.
                </Text>
                <Text textStyle="Regular" mt="1rem" fontSize={{ base: "text1", lg: "h4" }}>
                  As classes D e G não são utilizadas para pneus de passeio e camionete. Os pneus
                  grau "A" são a referência para uma frenagem à 80Km/h em asfalto molhado.
                </Text>

                <Text textStyle="Regular" mt="1rem">
                  À medida que a distância de frenagem aumenta o índice também aumenta (veja o
                  gráfico abaixo que representa as médias dessas distâncias, em metros).
                </Text>
                <Image
                  src="https://cdn.pneufree.com.br/LINGLONG/images/Site/etiqueta/r-aderencia2.jpg"
                  my="1rem"
                  alt="Inmetro"
                />
                <Text textStyle="Regular" fontSize="text1">
                  * Cálculo médio com base na tabela de desaceleração da norma EC 1222/2009
                  utilizando a equação de Torricelli.
                </Text>
              </Flex>
              {isWideVersion && (
                <Flex
                  w={{ base: "55%", lg: "246px" }}
                  h={{ base: "auto", lg: "409px" }}
                  position="relative"
                >
                  <Box
                    top={{ base: "30px", lg: "0" }}
                    left={{ base: "-110px", lg: "0" }}
                    position={{ base: "absolute", lg: "relative" }}
                    w={{ base: "346px", lg: "246px" }}
                    h={{ base: "509px", lg: "409px" }}
                    zIndex="-9"
                  >
                    <Image
                      src="https://cdn.pneufree.com.br/CMS/images/Geral/01-28-2020-14-26r-aderencia.png"
                      w="full"
                      alt="Inmetro"
                    />
                  </Box>
                </Flex>
              )}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem mb="0.5rem">
          <AccordionButton
            bgColor={"ll-blue.main"}
            borderRadius={"50px"}
            _hover={{
              opacity: "0.5"
            }}
          >
            <Box textAlign={"start"} color={"ll-white.main"} w={"full"}>
              RUÍDO EXTERNO
            </Box>
            <AccordionIcon color="white" />
          </AccordionButton>
          <AccordionPanel h={{ base: "auto", lg: "500px" }}>
            <Flex w="full" justifyContent="space-between">
              <Flex w={{ base: "full", lg: "60%" }} direction="column" mt="0.5rem">
                <Text textStyle="Regular">
                  O critério de ruído externo é apresentado em forma gráfica através de ondas
                  sonoras, seguido do número de decibéis. Pneus mais silenciosos proporcionam maior
                  conforto aos ouvidos dos passageiros do veículo. O nível sonoro é medido em
                  decibéis [dB] com escala logarítmica. O nível que causa desconforto ao ouvido
                  humano é de 80dB. Na escala do selo:
                </Text>

                <UnorderedList mt="1rem">
                  <ListItem>
                    <Text textStyle="Regular">
                      Uma onda significa nível de ruído menor ou igual a 69dB;
                    </Text>
                  </ListItem>
                  <ListItem mt="1rem" textStyle="Regular">
                    <Text textStyle="Regular">
                      Duas ondas é o equivalente a um ruído entre 69,1 e 72dB;
                    </Text>
                  </ListItem>
                  <ListItem mt="1rem">
                    <Flex direction="column">
                      <Text textStyle="Regular">Três ondas é o mesmo que um ruído entre:</Text>
                      <Text textStyle="Regular">- 72,1 e 75dB em carros de passeio;</Text>
                      <Text textStyle="Regular">- 72,1 e 77dB em veículos comerciais leves;</Text>
                      <Text textStyle="Regular">- 72,1 e 78dB em caminhões e ônibus.</Text>
                    </Flex>
                  </ListItem>
                </UnorderedList>
              </Flex>
              {isWideVersion && (
                <Flex
                  w={{ base: "55%", lg: "246px" }}
                  h={{ base: "auto", lg: "409px" }}
                  position={{ base: "relative", lg: "initial" }}
                >
                  <Box
                    top={{ base: "-40px", lg: "0" }}
                    left={{ base: "-40px", lg: "0" }}
                    position={{ base: "absolute", lg: "initial" }}
                    w={{ base: "346px", lg: "246px" }}
                    h={{ base: "509px", lg: "409px" }}
                    zIndex={{ base: "-9", lg: "0" }}
                  >
                    <Image
                      src="https://cdn.pneufree.com.br/CMS/images/Geral/01-28-2020-14-26r-ruido.png"
                      w="full"
                      alt="Inmetro"
                    />
                  </Box>
                </Flex>
              )}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem mb="0.5rem">
          <AccordionButton
            bgColor={"ll-blue.main"}
            borderRadius={"50px"}
            _hover={{
              opacity: "0.5"
            }}
          >
            <Box textAlign={"start"} color={"ll-white.main"} w={"full"}>
              CONPET
            </Box>
            <AccordionIcon color="white" />
          </AccordionButton>
          <AccordionPanel h={{ base: "auto", lg: "500px" }}>
            <Flex w="full" justifyContent="space-between">
              <Flex w={{ base: "full", lg: "60%" }} direction="column" mt="0.5rem">
                <Text textStyle="Regular">
                  O CONPET é um programa do Governo Federal, criado em 1991, por decreto
                  presidencial, para promover o desenvolvimento de uma cultura anti-desperdício no
                  uso dos recursos naturais não renováveis no Brasil, garantindo um país melhor para
                  as gerações futuras.
                </Text>
                <Text mt="1rem" textStyle="Regular">
                  Os principais objetivos do Programa são: racionalizar o consumo dos derivados do
                  petróleo e do gás natural; reduzir a emissão de gases poluentes na atmosfera;
                  promover a pesquisa e o desenvolvimento tecnológico; e fornecer apoio técnico para
                  o aumento da eficiência energética no uso final da energia.
                </Text>
              </Flex>
              {isWideVersion && (
                <Flex
                  w={{ base: "55%", lg: "246px" }}
                  h={{ base: "auto", lg: "409px" }}
                  position={{ base: "relative", lg: "initial" }}
                >
                  <Box
                    top={{ base: "-230px", lg: "0" }}
                    left={{ base: "0px", lg: "0" }}
                    position={{ base: "absolute", lg: "initial" }}
                    w={{ base: "346px", lg: "246px" }}
                    h={{ base: "509px", lg: "409px" }}
                    zIndex={{ base: "-9", lg: "0" }}
                  >
                    <Image
                      src="https://cdn.pneufree.com.br/CMS/images/Geral/01-28-2020-14-26r-conpet.png"
                      w="full"
                      alt="Inmetro"
                    />
                  </Box>
                </Flex>
              )}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem>
          <AccordionButton
            bgColor={"ll-blue.main"}
            borderRadius={"50px"}
            _hover={{
              opacity: "0.5"
            }}
          >
            <Box textAlign={"start"} color={"ll-white.main"} w={"full"}>
              INMETRO E OCP
            </Box>
            <AccordionIcon color="white" />
          </AccordionButton>
          <AccordionPanel h={{ base: "auto", lg: "500px" }}>
            <Flex w="full" justifyContent="space-between">
              <Flex w={{ base: "full", lg: "60%" }} direction="column" mt="0.5rem">
                <Text textStyle="Regular">
                  O Instituto Nacional de Metrologia, Qualidade e Tecnologia - INMETRO - é uma
                  autarquia federal, vinculada ao Ministério do Desenvolvimento, Indústria, e
                  Comércio Exterior, que atua como Secretaria Executiva do Conselho Nacional de
                  Metrologia, Normalização e Qualidade Industrial (Conmetro), colegiado
                  interministerial, que é o órgão normativo do Sistema Nacional de Metrologia,
                  Normalização e Qualidade Industrial (Sinmetro).
                </Text>

                <Text mt="1rem" textStyle="Regular">
                  OCP é o organismo certificado pelo INMETRO (laboratório) que executa os testes do
                  representante legal da marca.
                </Text>
              </Flex>
              {isWideVersion && (
                <Flex
                  w={{ base: "55%", lg: "246px" }}
                  h={{ base: "auto", lg: "409px" }}
                  position={{ base: "relative", lg: "initial" }}
                >
                  <Box
                    top={{ base: "50px", lg: "0" }}
                    left={{ base: "-110px", lg: "0" }}
                    position={{ base: "absolute", lg: "initial" }}
                    w={{ base: "346px", lg: "246px" }}
                    h={{ base: "509px", lg: "409px" }}
                    zIndex={{ base: "-9", lg: "0" }}
                  >
                    <Image
                      src="https://cdn.pneufree.com.br/CMS/images/Geral/01-28-2020-14-26r-inmetro.png"
                      w="full"
                      alt="Inmetro"
                    />
                  </Box>
                </Flex>
              )}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </ModalDefault>
  );
}
